import config from "@/config";
import http from "@/utils/request";

export default {
	activityUser: {
		//分销员列表（GET，行含user.nickname/avatar/spread{one,two,total}，返回extend{spread_count,lower_count,spread_order_count,spread_order_price}统计；注意分销权限未开启时后端报错）
		index: {
			url: `${config.API_URL}/bwmall/admin/activity/user/index`,
			name: "分销员列表",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//属性修改（POST：id/field/value，field仅支持status/sort/remark/is_delete/is_auth/title/is_promoter，主副表同步）
		modify: {
			url: `${config.API_URL}/bwmall/admin/activity/user/modify`,
			name: "分销员属性修改",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//下级统计（GET ?bw_user_id=，filter带level：0全部/1一级/2二级，返回extend{spread_count一级,lower_count二级,spread_order_count全部}）
		lowerLevel: {
			url: `${config.API_URL}/bwmall/admin/activity/user/lowerLevel`,
			name: "推广下级统计",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//分销订单（GET ?bw_user_id=，filter带level：0全部/1一级/2二级，返回extend含订单金额/数量/返佣9项统计）
		lowerOrder: {
			url: `${config.API_URL}/bwmall/admin/activity/user/lowerOrder`,
			name: "分销订单统计",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//推广码（GET ?id=，返回{mini_url小程序码,web_url公众号二维码}；要求is_promoter=1且已配置分享路由）
		qrcode: {
			url: `${config.API_URL}/bwmall/admin/activity/user/qrcode`,
			name: "推广码",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		}
	}
}
